import { deleteDoc, orderBy } from "firebase/firestore"
import useQuery from "hooks/firestore/core/useQuery"
import { getBroadcastsRef } from "hooks/firestore/getRefs"
import { useShop } from "hooks/firestore/simple/useShop"
import Link from "next/link"

export default function Overview({ startEditingNewsletter }: { startEditingNewsletter: (id: string) => void }) {
  const shop = useShop()
  const { documents: sentNewsletters, loading } = useQuery(getBroadcastsRef(shop?._ref.id), orderBy("sentAt", "desc"))

  if (loading) return <>Bitte warten...</>

  const orderedNewsletters = sentNewsletters?.sort((a, b) => {
    if (a.isDraft && !b.isDraft) return -1
    if (!a.isDraft && b.isDraft) return 1
    return 0
  })

  return orderedNewsletters?.length ? (
    <table style={{ width: "100%" }}>
      <thead>
        <tr>
          <th>Betreff</th>
          <th style={{ textAlign: "right", padding: "0 1rem" }}>Anzahl Empfänger</th>

          <th>Datum</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {orderedNewsletters.map(nl => (
          <tr key={nl._ref.id}>
            <td>{nl.subject}</td>
            <td style={{ textAlign: "right", padding: "0 1rem" }}>{nl.recipients}</td>
            <td>
              {nl.scheduledTimeUnix ? (
                <>
                  Geplant: {new Date(nl.scheduledTimeUnix * 1000).toLocaleDateString("de-DE")} -{" "}
                  {new Date(nl.scheduledTimeUnix * 1000).toLocaleTimeString("de-DE")}
                </>
              ) : nl.sentAt ? (
                <>
                  {nl.sentAt.toDate().toLocaleDateString("de-DE")} - {nl.sentAt.toDate().toLocaleTimeString("de-DE")}
                </>
              ) : (
                "-"
              )}
            </td>
            <td>
              {nl.isDraft ? (
                <div className="tw-flex tw-items-center tw-gap-2">
                  <button
                    className="tw-bg-gray-100 tw-text-gray-700 tw-rounded-lg tw-px-2 tw-py-1 tw-text-sm tw-no-underline"
                    onClick={() => startEditingNewsletter(nl._ref.id)}
                  >
                    Bearbeiten
                  </button>
                  <button
                    className="tw-bg-red-primary/10 tw-text-red-primary tw-rounded-lg tw-px-2 tw-py-1 tw-text-sm tw-no-underline"
                    onClick={() => deleteDoc(nl._ref)}
                  >
                    Löschen
                  </button>
                </div>
              ) : (
                <Link href={`/admin/marketing/newsletter/${nl._ref.id}`}>
                  <a className="tw-bg-green-primary/10 tw-text-green-primary tw-rounded-lg tw-px-2 tw-py-1 tw-text-sm tw-no-underline">
                    Anzeigen
                  </a>
                </Link>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <div>
      <p>Du hast noch keine Newsletter versendet.</p>
    </div>
  )
}
